<mat-card><mat-card-title>Links</mat-card-title>
    <mat-card-content>
        <p *ngFor="let link of links">{{link}}</p>
    </mat-card-content></mat-card>
